<script>
  import ProductPrice from '@/components/Ecommerce/Products/ProductPrice'

  export default {
    components: {
      ProductPrice
    },
    props: {
      amount: {
        type: Number,
        required: true
      },
      label: {
        type: String,
        required: true
      }
    }
  }
</script>

<template>
  <div class="flex items-center justify-between">
    <span>
      {{ label }}
    </span>
    <ProductPrice
      :price="amount"
      show-decimals
    />
  </div>
</template>
